(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["onieer-product-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('onieer-size-guide')) {
    customElements.define('onieer-size-guide', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.addEventListener('click', event => {
          const dialog = this.querySelector('dialog');
          const trigger = event.target.closest('.onieer-sizes__trigger');
          if (trigger && typeof dialog?.showModal === 'function' && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
            event.preventDefault();
            this.trigger = trigger;
            if (!dialog.open) dialog.showModal();
          }
          if (event.target.closest('[data-size-close]')) dialog?.close();
          if (event.target === dialog) {
            const bounds = dialog.getBoundingClientRect();
            if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
          }
        }, { signal });
        this.addEventListener('close', event => {
          if (event.target.matches('.onieer-sizes__dialog')) this.trigger?.focus({preventScroll:true});
        }, { capture:true, signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["onieer-product-promo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('onieer-product-promo')) {
    customElements.define('onieer-product-promo', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.addEventListener('click', event => {
          const button = event.target.closest('.onieer-promo__pause');
          if (!button) return;
          const paused = this.toggleAttribute('data-paused');
          button.setAttribute('aria-pressed', String(paused));
          button.setAttribute('aria-label', paused ? 'Resume promotional messages' : 'Pause promotional messages');
          button.querySelector('span').textContent = paused ? '▷' : 'Ⅱ';
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
